import withComponentName from '../../../../../decorators/withComponentName';

import DashedLineComponent from '../../../../DashedLineComponent';

const getNewSourcesLine = (left, top) => {
  const startLine = {
    left,
    top,
  };
  return `M${startLine.left},${startLine.top} v115`;
};

const BackgroundNewSources = ({ width }) => {
  if (width <= 1120) return null;
  return (
    <DashedLineComponent
      coords={getNewSourcesLine(0, 0)}
    />
  );
};

export default withComponentName(BackgroundNewSources);
